var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "client"
  }, [_c('div', [_c('div', {
    staticClass: "container-fluid"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit()
      }
    }
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 row"
  }, [(_vm.singleChannel.saleschannel != '') ? _c('div', {
    staticClass: "col-md-3",
    attrs: {
      "disabled": true
    }
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchchannel1),
      expression: "searchchannel1"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchchannel1",
      "disabled": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchchannel1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("orders.salesChannelPlaceHolder")) + "\n                    ")]), _vm._v(" "), _vm._l((_vm.allchannels), function(channel) {
    return _c('option', {
      domProps: {
        "value": channel.saleschannel
      }
    }, [_vm._v("\n                      " + _vm._s(channel.saleschannel) + "\n                    ")])
  })], 2)])], 1) : _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchchannel1),
      expression: "searchchannel1"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchchannel1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchchannel1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("orders.salesChannelPlaceHolder")) + "\n                    ")]), _vm._v(" "), _vm._l((_vm.nonselectedChannelList), function(channel) {
    return _c('option', {
      domProps: {
        "value": channel.saleschannel
      }
    }, [_vm._v("\n                      " + _vm._s(channel.saleschannel) + "\n                    ")])
  })], 2)]), _vm._v(" "), (_vm.searchchannel1 == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('sla.saleschannelrequired')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.$t('sla.tattype')) + " :")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "4px 10px"
    }
  }, [_c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tatType),
      expression: "tatType"
    }],
    staticStyle: {
      "z-index": "1 !important"
    },
    attrs: {
      "type": "radio",
      "name": _vm.singleChannel.name,
      "value": "1"
    },
    domProps: {
      "checked": _vm.tatType == '1',
      "checked": _vm._q(_vm.tatType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.tatType = "1"
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_vm._v(" " + _vm._s(_vm.$t('sla.fixeduration')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "4px 10px"
    }
  }, [_c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tatType),
      expression: "tatType"
    }],
    staticStyle: {
      "z-index": "1 !important"
    },
    attrs: {
      "type": "radio",
      "name": _vm.singleChannel.name,
      "value": "2"
    },
    domProps: {
      "checked": _vm.tatType == '2',
      "checked": _vm._q(_vm.tatType, "2")
    },
    on: {
      "change": _vm.transitFixedDurAndCutoffBased,
      "__c": function($event) {
        _vm.tatType = "2"
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_vm._v(" " + _vm._s(_vm.$t('sla.cutoffbased')) + " ")])])])]), _vm._v(" "), (_vm.tatType == '1') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v(_vm._s(_vm.$t('sla.duration')))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:167'),
      expression: "'required|min_value:1|max_value:167'"
    }],
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "name": "hr",
      "id": "hr",
      "min": "0",
      "max": "167"
    },
    on: {
      "keyup": function($event) {}
    },
    model: {
      value: (_vm.outbound.fixedhrs),
      callback: function($$v) {
        _vm.outbound.fixedhrs = $$v
      },
      expression: "outbound.fixedhrs"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:59'),
      expression: "'required|min_value:1|max_value:59'"
    }],
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "name": "min",
      "id": "min",
      "min": "0",
      "max": "59"
    },
    on: {
      "keyup": function($event) {}
    },
    model: {
      value: (_vm.outbound.fixedmin),
      callback: function($$v) {
        _vm.outbound.fixedmin = $$v
      },
      expression: "outbound.fixedmin"
    }
  })], 1)], 1), _vm._v(" "), (_vm.fixedErr) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.fixedErr))])]) : _vm._e()]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 row",
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v(_vm._s(_vm.$t('sla.ordercreationcutoff')))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:7'),
      expression: "'required|min_value:1|max_value:7'"
    }],
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.day'),
      "name": "day",
      "id": "day",
      "min": "1",
      "max": "7",
      "disabled": ""
    },
    on: {
      "keyup": function($event) {}
    },
    model: {
      value: (_vm.outbound.cuttofday),
      callback: function($$v) {
        _vm.outbound.cuttofday = $$v
      },
      expression: "outbound.cuttofday"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:24'),
      expression: "'required|min_value:1|max_value:24'"
    }],
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "name": "hr",
      "id": "hr",
      "min": "0",
      "max": "24"
    },
    on: {
      "keyup": function($event) {}
    },
    model: {
      value: (_vm.outbound.cuttofhrs),
      callback: function($$v) {
        _vm.outbound.cuttofhrs = $$v
      },
      expression: "outbound.cuttofhrs"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:59'),
      expression: "'required|min_value:1|max_value:59'"
    }],
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "name": "min",
      "id": "min",
      "min": "0",
      "max": "59"
    },
    on: {
      "keyup": function($event) {}
    },
    model: {
      value: (_vm.outbound.cuttofmin),
      callback: function($$v) {
        _vm.outbound.cuttofmin = $$v
      },
      expression: "outbound.cuttofmin"
    }
  })], 1)], 1), _vm._v(" "), (_vm.cuttofErr) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.cuttofErr))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row",
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v(_vm._s(_vm.$t('sla.outboundsla')))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:7'),
      expression: "'required|min_value:1|max_value:7'"
    }],
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.day'),
      "name": "day",
      "id": "day",
      "min": "1",
      "max": "7"
    },
    on: {
      "keyup": function($event) {}
    },
    model: {
      value: (_vm.outbound.orderday),
      callback: function($$v) {
        _vm.outbound.orderday = $$v
      },
      expression: "outbound.orderday"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:24'),
      expression: "'required|min_value:1|max_value:24'"
    }],
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "name": "hr",
      "id": "hr",
      "min": "0",
      "max": "24"
    },
    on: {
      "keyup": function($event) {}
    },
    model: {
      value: (_vm.outbound.orderhrs),
      callback: function($$v) {
        _vm.outbound.orderhrs = $$v
      },
      expression: "outbound.orderhrs"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:59'),
      expression: "'required|min_value:1|max_value:59'"
    }],
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "name": "min",
      "id": "min",
      "min": "0",
      "max": "59"
    },
    on: {
      "keyup": function($event) {}
    },
    model: {
      value: (_vm.outbound.ordermin),
      callback: function($$v) {
        _vm.outbound.ordermin = $$v
      },
      expression: "outbound.ordermin"
    }
  })], 1)], 1), _vm._v(" "), (_vm.outboundErr) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.outboundErr))])]) : _vm._e()])]), _vm._v(" "), (_vm.singleChannel.saleschannel == '') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("common.saveBtn")) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("\n                 " + _vm._s(_vm.$t("common.resetBtn")) + "\n              ")])])]) : _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("common.updateBtn")) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.deleteChannel()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("common.delete")) + "\n              ")])])]), _vm._v(" "), _c('br'), _c('br')])])])])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e7fdb006", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7fdb006","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SLA/saleschannel/index.vue
// module id = 2149
// module chunks = 0